(function() {
  'use strict';

  var STORAGE_KEY = 'mnb_viewed';
  var MAX_VIEWED = 5;

  // Track viewed product (for product pages)
  function trackViewedProduct(productId) {
    if (!productId) return;

    try {
      var viewed = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
      var id = String(productId);

      // Remove if already exists (to move to front)
      var filtered = viewed.filter(function(v) { return v !== id; });

      // Add to front
      filtered.unshift(id);

      // Keep only last MAX_VIEWED
      localStorage.setItem(STORAGE_KEY, JSON.stringify(filtered.slice(0, MAX_VIEWED)));
    } catch (e) {
      // localStorage not available
    }
  }

  // Get viewed products from localStorage
  function getViewedProducts() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
    } catch (e) {
      return [];
    }
  }

  function getHandle(product) {
    if (product.handle) return product.handle;
    if (!product.url) return null;
    var match = String(product.url).match(/\/products\/([^\/?#]+)/);
    return match ? match[1] : null;
  }

  function fetchProductCard(handle, parser) {
    return fetch('/products/' + handle + '?section_id=bike-finder-product-card')
      .then(function(res) { return res.ok ? res.text() : null; })
      .then(function(html) {
        if (!html) return null;
        var doc = parser.parseFromString(html, 'text/html');
        return doc.body.firstElementChild;
      })
      .catch(function() { return null; });
  }

  // Fetch and render recommendations
  function loadRecommendations(container, productIds, excludeIds) {
    var url = container.dataset.url;
    var limit = container.dataset.limit || 8;

    if (!url || productIds.length === 0) {
      container.style.display = 'none';
      return;
    }

    var params = 'ids=' + encodeURIComponent(productIds.join(',')) + '&limit=' + limit;
    if (excludeIds && excludeIds.length > 0) {
      params += '&exclude=' + encodeURIComponent(excludeIds.join(','));
    }

    fetch(url + '?' + params)
      .then(function(res) { return res.json(); })
      .then(function(data) {
        var grid = container.querySelector('[data-recommendations-grid]');
        if (!grid) return;

        if (!data.recommendations || data.recommendations.length === 0) {
          container.style.display = 'none';
          return;
        }

        var parser = new DOMParser();
        return Promise.all(data.recommendations.map(function(product) {
          var handle = getHandle(product);
          return handle ? fetchProductCard(handle, parser) : null;
        })).then(function(cards) {
          while (grid.firstChild) {
            grid.removeChild(grid.firstChild);
          }

          for (var i = 0; i < cards.length; i++) {
            if (cards[i]) grid.appendChild(cards[i]);
          }

          if (!grid.firstChild) {
            container.style.display = 'none';
            return;
          }

          container.style.display = '';
        });
      })
      .catch(function() {
        container.style.display = 'none';
      });
  }

  // Initialize product page recommendations
  function initProductRecommendations() {
    var container = document.getElementById('product-recommendations');
    if (!container) return;

    var productId = container.dataset.productId;
    if (!productId) return;

    // Track this product view
    trackViewedProduct(productId);

    // Load recommendations
    loadRecommendations(container, [productId], [productId]);
  }

  // Initialize home page recommendations
  function initHomeRecommendations() {
    var container = document.getElementById('home-recommendations');
    if (!container) return;

    var viewed = getViewedProducts();
    if (viewed.length === 0) {
      container.style.display = 'none';
      return;
    }

    // Load recommendations based on viewed products, excluding those same products
    loadRecommendations(container, viewed, viewed);
  }

  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initProductRecommendations();
      initHomeRecommendations();
    });
  } else {
    initProductRecommendations();
    initHomeRecommendations();
  }
})();
